import { render, staticRenderFns } from "./FuncModal.vue?vue&type=template&id=132faa05&scoped=true&"
import script from "./FuncModal.vue?vue&type=script&lang=js&"
export * from "./FuncModal.vue?vue&type=script&lang=js&"
import style0 from "./FuncModal.vue?vue&type=style&index=0&id=132faa05&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132faa05",
  null
  
)

export default component.exports